/**
 * 认证服务 - 用户登录/注册/KYC
 */
import { api, setToken, clearToken } from './api'

export interface SendSmsParams {
  phone: string
}

export interface LoginByPhoneParams {
  phone: string
  code: string
}

export interface LoginResponse {
  accessToken: string
  refreshToken: string
  user: UserInfo
}

export interface UserInfo {
  id: string
  phone: string
  nickname?: string
  avatar?: string
  kycStatus: 'unverified' | 'pending' | 'verified' | 'rejected'
  walletAddress?: string
  createdAt: string
}

export interface RealNameVerifyParams {
  realName: string
  idCard: string
}

export const authService = {
  /** 发送短信验证码 */
  sendSmsCode(phone: string): Promise<{ success: boolean; message: string }> {
    return api.post('/auth/sms/send', { phone })
  },

  /** 手机号+验证码登录/注册 */
  async loginByPhone(params: LoginByPhoneParams): Promise<LoginResponse> {
    const result = await api.post<LoginResponse>('/auth/login/phone', params)
    setToken(result.accessToken, true)
    return result
  },

  /** 刷新Token */
  refreshToken(refreshToken: string): Promise<{ accessToken: string; refreshToken: string }> {
    return api.post('/auth/refresh', { refreshToken })
  },

  /** 实名认证 */
  verifyRealName(params: RealNameVerifyParams): Promise<UserInfo> {
    return api.post('/auth/kyc/realname', params)
  },

  /** 获取当前用户信息 */
  getProfile(): Promise<UserInfo> {
    return api.get('/auth/me')
  },

  /** 退出登录 */
  logout(): void {
    clearToken()
  },
}

export default authService
